import axios from '@/utils/axios';

// Types

export interface AccountResponseModel {
	id: number;
	label: string;
	balance: number;
	isCollective: boolean;
	users: any[];
}

export class CreditRequestModel {
	amount!: number;
	accountToCreditID!: number;
}

// API

export default {
	async getOne(id: number): Promise<AccountResponseModel> {
		return (await axios().get(`/accounts/${id}/`)).data;
	},
	async credit(payload: CreditRequestModel) {
		const location = (await axios().post("accounts/credit", payload)).data;
		window.location.href = location;
	},
	async getPaymentModul() {
		return (await axios().get(`/accounts/paymentmodul`)).data;
	},
	async getPayzenForm(payload: CreditRequestModel): Promise<string> {
		return (await axios().post("accounts/payzenform", payload)).data;
	}

};
